import { render, staticRenderFns } from "./bannersConsorcios.vue?vue&type=template&id=97cac054&scoped=true"
import script from "./bannersConsorcios.ts?vue&type=script&lang=ts&external"
export * from "./bannersConsorcios.ts?vue&type=script&lang=ts&external"
import style0 from "./bannersConsorcios.vue?vue&type=style&index=0&id=97cac054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cac054",
  null
  
)

export default component.exports